import { EventEmitter } from 'events';

/**
 * @class Store
 * @extends EventEmitter
 */
export default class Store extends EventEmitter {
  /**
   * @param {*=} data The initial data of the store
   */
  constructor (data) {
    super();
    data = data || {};

    this._data = data;
    this.data = Store.deepClone(data);
    this.UPDATE = 'up';

    // to avoid max listeners warning
    this.setMaxListeners(100);

    this.init();
  }

  init () {
    console.error('The current store does not declare the init function.\nDeclare your listeners in the init function', this);
  }

  reset () {
    this.data = Store.deepClone(this._data);
  }

  done () {
    this.emit(this.UPDATE, this.data);
  }

  onUpdate (cb) {
    this.on(this.UPDATE, cb);
  }

  removeUpdateListener (cb) {
    this.removeListener(this.UPDATE, cb);
  }

  static deepClone (data) {
    return JSON.parse(JSON.stringify(data));
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/flux/Store.js